import React from 'react';
import { useGame } from '../context/GameContext';

export default function Celebration() {
  const { celebration } = useGame();
  if (!celebration) return null;
  return (
    <div className="celebration-overlay">
      <div className="celebration-burst">
        {[...Array(12)].map((_, i) => (
          <div key={i} className="burst-particle" style={{ '--i': i }} />
        ))}
      </div>
      <div className="celebration-text">
        <span className="cel-plus">+{celebration}</span>
        <span className="cel-hp">HP</span>
      </div>
      <div className="celebration-msg">INTENTION COMPLETE!</div>
    </div>
  );
}
